




















import PrimitiveDataSelector from '@/components/primitive-editor/types/PrimitiveDataSelector.vue';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'InputDocuments',
  components: {
    PrimitiveDataSelector,
  },
  props: {
    multiple: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Array,
      default: () => [],
    },
    tags: {
      type: [Object, Array],
      default: () => ({ option: 'exclude', tags: 'template' }),
    },
  },
});
